RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s) {

    'use strict';

    widgets._PostDetail = RivalIQ.views.LayoutView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler,
            postTagsReload: RivalIQ.apps.SocialPosts.mixins.PostTagsReload
        },

        template: '#widgetInsightsPostDetailTemplate',

        ui: {
            popover: `[data-toggle='popover']`
        },

        regions: {
            postTagPills: '.post-tag-pills'
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            const showPostTags = me.getProp('showPostTags');

            RivalIQ.postTags.utils.updateBodyClass(undefined, showPostTags);
        },

        onRender: function () {
            const me = this;

            me.ui.popover.popover({
                html: true
            });

            me.requestRenderedFrame(function () {
                me.postTagPills.show(new RivalIQ.apps.SocialPosts.views.PostTagPills({
                    post: me.model,
                    postTagsById: me.dashboardModel.postTagsById || {},
                    parentDashboardModel: me.dashboardModel,
                    postTagsClickable: false,
                    showActionBtns: false
                }));
            });
        },

        loadData: function () {
            const me = this;

            const metric = me.dashboardModel.metric;

            return $.when(
                metric.fetch(),
                RivalIQ.postTags.data.PostTags.fetch()
            ).then(function (metric, postTags) {
                const data = _.extend({
                    display: metric.data.rivaliq.display
                }, metric.data);
                me.model = new RivalIQ.models.Post(data, metric);

                me.dashboardModel.postTagsById = _.keyBy(postTags, 'id');
            });
        },

        templateHelpers: function () {
            const me = this;
            const postSource = me.model.get('source');

            return _.extend({
                s: s,
                boostedPostPopoverTemplate: Marionette.TemplateCache.get('#tableCellTooltip'),
                channel: RivalIQ.data.channels.get(postSource),
                isLikelyPromoted: false, // always hide for insights
                isRestricted: me.model.get('is_restricted')
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        serializeData: function () {
            const me = this;
            const post = me.model.toJSON();

            const messageWithParagraphs = _.map((_.get(post, ['display', 'message']) || '').split(/\n+/), function (para) {
                return $.tagHtml('p', {
                    text: para
                });
            }).join('\n');

            const boostedPosts = RivalIQ.state.account.channelDisplay(RivalIQ.enums.sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS);
            if (!boostedPosts) {
                post.boosted_post_total_spend = null;
            }

            const publishedAt = post.published_at;
            const capturedAt = post.captured_at;

            let timezone;
            try {
                timezone = me.getProp('timezone');
            } catch (e) {
                timezone = 'UTC';
            }

            const publishedAtInTz = RivalIQ.utils.timezone.getDateInTimezone(timezone, publishedAt);
            const capturedAtInTz = RivalIQ.utils.timezone.getDateInTimezone(timezone, capturedAt);

            return _.extend(post, {
                id: [post.source, post.id].join('.'),
                message: messageWithParagraphs,
                publishedAtStr: `${publishedAtInTz.format('MMM D, YYYY LT')} ${RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, publishedAt)}`,
                dateCapturedStr: `${capturedAtInTz.format('MMM D, YYYY LT')} ${RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, capturedAt)}`,
                useCdnThumbnail: _.get(post, 'useCdnThumbnail', false)
            });
        }
    });

    const fbInsightsPostPanel = RivalIQ.apps.Dashboard.views.Panel.extend({
        showActions: function () {
            const me = this;

            me.actions.show(new RivalIQ.views.ShowPostTagsSwitch({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });

            RivalIQ.apps.Dashboard.views.Panel.prototype.showActions.call(me, arguments);
        }
    });

    const FbInsightsPostDetailsWidget = widgets.PostDetailsWidgetBase.mixin({
        title: RivalIQ.strings.facebook_insights_post_detail_post_details_title,
        description: RivalIQ.strings.facebook_insights_post_detail_post_details_description,
        view: widgets._PostDetail,
        panelClassName: 'fb-post-details-overview',
        panelView: fbInsightsPostPanel
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_DETAILS, FbInsightsPostDetailsWidget);

    const FbInsightsReelDetailsWidget = FbInsightsPostDetailsWidget.mixin({
        title: RivalIQ.strings.facebook_insights_reel_detail_reel_details_title,
        description: RivalIQ.strings.facebook_insights_reel_detail_reel_details_description
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_REEL_DETAILS, FbInsightsReelDetailsWidget);

}, window.s);
